import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function LlmTraslator() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [translationResult, setTranslationResult]= useState('Buenos días.')
    const [userInput, setUserInput] = useState({'en':'Good morning.'})
    const onChange2Input = ({ currentTarget: x }) => { setUserInput({ ...userInput, [x.name]: x.value }) }
    const onClick2Translate =async()=>{
        setLoadingMsg(true)
        setTranslationResult('')
        try {
            const { data: res } = await axios.post(`${APIURL}/llm/translator/en-es`,userInput)
            setLoadingMsg(false)
            setTranslationResult(res['es'])
        } catch (err) {
            console.log(err)
        }
    }
    return (
        <>
        <div className='mt-[2px] flex'>
        <input className='pl-[2px] border border-gray-800 w-full md:w-[170px] mr-[2px] text-[9px]' name='en' type='text' defaultValue='Good morning.' onChange={onChange2Input}/>
        <button disabled={loadingMsg} className={`hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-auto pl-[8px] pr-[8px] text-white text-[9px]`} onClick={onClick2Translate}>Translate it</button>
        </div>
        {loadingMsg?<p className='flex text-xs'>Please wait for 5seconds<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:<>{translationResult}</>}
        </>
    )
}
